<template>
  <button
    class="underline text-lg"
    @click="setPopupTitle(locationTitle)"
  >
    {{ strings.map.view_on_map }}
  </button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('map')

export default {
  props: {
    locationTitle: { type: String, default: null },
  },
  data() {
    return {
      strings: window.themeVariables.i18n,
    }
  },
  methods: {
    ...mapMutations(['setPopupTitle']),
  },
}
</script>